import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=354f9876&scoped=true"
import script from "./Transfer.vue?vue&type=script&lang=js"
export * from "./Transfer.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/inventory.css?vue&type=style&index=0&id=354f9876&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f9876",
  null
  
)

export default component.exports